function initMediaGalleryCarousels(scope = document, attempt = 0) {
  const carousels = scope.querySelectorAll('[id^="media-gallery-"]');

  if (!carousels.length) return;

  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
    if (attempt < 20) {
      window.setTimeout(function () {
        initMediaGalleryCarousels(scope, attempt + 1);
      }, 150);
    }
    return;
  }

  const $ = window.jQuery;

  carousels.forEach((carousel) => {
    if (carousel.classList.contains('slick-initialized')) return;

    const options = {
      arrows: carousel.dataset.arrows == 'true',
      lazyLoad: 'ondemand',
      dots: carousel.dataset.dots == 'true',
      infinite: carousel.dataset.infinite == 'true',
      autoplay: carousel.dataset.autoplay == 'true',
      autoplaySpeed: parseInt(carousel.dataset.autoplaySpeed || '3000', 10),
      slidesToShow: parseInt(carousel.dataset.slidesToShow || '3', 10),
      slidesToScroll: parseInt(carousel.dataset.slidesToScroll || '1', 10),
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide">&lsaquo;</button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next slide">&rsaquo;</button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: parseInt(carousel.dataset.slidesToShowMobile || '1', 10),
            slidesToScroll: 1
          }
        }
      ]
    };

    try {
      $(carousel).slick(options);
    } catch (error) {
      if (window.console && window.console.warn) {
        window.console.warn('Media gallery carousel failed to initialize.', error);
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", function () {
    initMediaGalleryCarousels();
  });
} else {
  initMediaGalleryCarousels();
}

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initMediaGalleryCarousels(event.target);
  });
}
